import { useEffect } from 'react';

// Replace with your Crisp Website ID from https://app.crisp.chat/settings/website/
const CRISP_WEBSITE_ID = 'f002e3ff-768f-4400-b84c-282b0ffe8869';

// Extend window type for Crisp
declare global {
  interface Window {
    $crisp: unknown[];
    CRISP_WEBSITE_ID: string;
  }
}

/**
 * Crisp Live Chat Integration
 * 
 * Setup Instructions:
 * 1. Go to https://crisp.chat and create a free account
 * 2. Add your website (webbuilders.live)
 * 3. Go to Settings > Website Settings > Setup Instructions
 * 4. Copy your Website ID (looks like: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
 * 5. Replace 'YOUR_CRISP_WEBSITE_ID' above with your actual ID
 * 
 * Features included in free tier:
 * - Live chat widget
 * - 2 team seats
 * - Mobile apps (iOS/Android)
 * - Chat triggers
 * - Email notifications
 */
export default function LiveChat() {
  useEffect(() => {
    // Don't load if no website ID configured
    // if (CRISP_WEBSITE_ID === 'YOUR_CRISP_WEBSITE_ID') {
    //   console.warn('Crisp: Please configure your Website ID in LiveChat.tsx');
    //   return;
    // }

    // Initialize Crisp
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

    // Load Crisp script
    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);

    // Optional: Customize Crisp appearance
    script.onload = () => {
      // Set chat color to match your brand
      if (window.$crisp) {
        window.$crisp.push(['config', 'color:theme', ['blue']]);
        
        // Optional: Set position (bottom-right is default)
        // window.$crisp.push(['config', 'position:reverse', [true]]); // bottom-left
        
        // Optional: Hide by default and show programmatically
        // window.$crisp.push(['do', 'chat:hide']);
      }
    };

    // Cleanup on unmount
    return () => {
      const existingScript = document.querySelector('script[src="https://client.crisp.chat/l.js"]');
      if (existingScript) {
        existingScript.remove();
      }
      // Clean up Crisp globals
      delete (window as Partial<Window>).$crisp;
      delete (window as Partial<Window>).CRISP_WEBSITE_ID;
    };
  }, []);

  // Crisp handles its own UI - no need to render anything
  return null;
}